import { getLogger } from "@expert/logging";
import { getCustomerDetailsApi } from "./api";

const logger = getLogger({
    module: "update-case",
    supportTeam: "platform",
});

interface UpdateCaseRequestBody {
    caseId: string;
    subject: string;
    description: string;
    category?: string;
    subcategory?: string;
}

export const updateCase = async (
    request: UpdateCaseRequestBody,
): Promise<{ caseId: string; caseNumber: string } | null> => {
    try {
        const client = getCustomerDetailsApi();
        const apiPath = `v1/case/${request.caseId}`;
        return await client.post(apiPath, { json: request, retry: 0 }).json<{ caseId: string; caseNumber: string }>();
    } catch (err: unknown) {
        logger.error({ err }, `update case failed`);
        throw err;
    }
};
